import { render, staticRenderFns } from "./SetPlayer.vue?vue&type=template&id=658e3656&"
import script from "./SetPlayer.vue?vue&type=script&lang=js&"
export * from "./SetPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports